import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { VIEW, YES, ACTIVE } from "const"
import { hasProjectAccess } from "client/utils"
import {
    PRM_CC_COMPLIANCE,
    StoreType,
    setCcComplianceBaseRoute,
    moduleIds,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    projectCcComplianceRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"
import ComplianceList from "./list"

const CcCompliance = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const dispatch = useDispatch()

    const { ccModuleAccess } = packageSettings
    const moduleAccess = ccModuleAccess === YES && moduleList[moduleIds.cc].status === ACTIVE
    const viewAccess = hasProjectAccess(PRM_CC_COMPLIANCE, VIEW)

    const baseRouteMask = `${projectBaseRoute}${projectCcComplianceRoute}`
    const baseRoute = `${projectsRoute}/${VIEW}/${project.id}${projectCcComplianceRoute}`

    useEffect(() => {
        dispatch(setCcComplianceBaseRoute(baseRoute))
    }, [])

    if (!moduleAccess || !viewAccess) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/set/:setId/revision/:revisionId/item/:itemId`}
                component={ComplianceList}
            />
            <Route
                path={baseRouteMask}
                component={ComplianceList}
            />
        </Switch>
    )
}
export default CcCompliance
